import { render, staticRenderFns } from "./firebase_login_component.vue?vue&type=template&id=0b481866&"
import script from "./firebase_login_component.vue?vue&type=script&lang=js&"
export * from "./firebase_login_component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports